import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-navy text-gold">
        <Loader2 className="h-10 w-10 animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
};
